module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av555-7fffe0ded7752a0813d6fb03090d60ac.jpg";